export function initialsFromUser(user) {
  if (!user) return '?';
  const e = user.email || '';
  const n = String(user.displayName || e.split('@')[0] || '?').trim();
  const p = n.split(/\s+/).filter(Boolean);
  if (p.length >= 2) return (p[0][0] + p[1][0]).toUpperCase();
  return n.slice(0, 2).toUpperCase() || '?';
}

export function initialsFromNameEmail(name, email) {
  const n = String(name || email || '?').trim();
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return n.slice(0, 2).toUpperCase() || '?';
}
